// extracted by mini-css-extract-plugin
module.exports = {"coinHistory":"CoinHistory_coinHistory__SpqJ1","itemBlock":"CoinHistory_itemBlock__KhqAz","itemUsed":"CoinHistory_itemUsed__CIQUy","itemCoin":"CoinHistory_itemCoin__XxoIJ"};